// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2lSho","header":"PatientBlock_header__34yjN","label":"PatientBlock_label__ahAPY","option":"PatientBlock_option__EWhsL"};